import React, { FC } from 'react'

export const HeaderRightBlockPortal: FC = () => {
  return <div id={HEADER_PORTAL_ID} />
}

export const HeaderLeftBlockPortal: FC = () => {
  return <div id={HEADER_PORTAL_ID} />
}

const HEADER_PORTAL_ID = 'header-portal-id'

export const findHeaderPortalElement = () =>
  document.getElementById(HEADER_PORTAL_ID)
